module.exports = __webpack_public_path__ + "static/media/third_day.589a95fe.svg";